import React from 'react';
import { Outlet } from 'react-router-dom';

import { MainHeader } from '../headers/main-header';

const AppLayout = ({ isHeader }) => {
  return (
    <div>
      {isHeader && <MainHeader />}
      <Outlet />
    </div>
  );
};

export { AppLayout };
